import { createContext, useContext } from 'react';

interface ComponentFocusContextValue {
  isComponentFocused: boolean;
  setComponentFocused: VoidFunction;
  setComponentBlurred: VoidFunction;
}

const defaultValue: ComponentFocusContextValue = {
  isComponentFocused: false,
  setComponentFocused: () => {},
  setComponentBlurred: () => {},
};

export const ComponentFocusContext = createContext<ComponentFocusContextValue>(defaultValue);

export function useComponentFocus() {
  return useContext(ComponentFocusContext);
}
